module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image2@2x-91169aca2e2b6a18dcbaff6cc2000b63.jpg";